// import { InputFactory } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import EmployeeFormPresenter from "../employee-form/EmployeeFormPresenter";
import Divider from "../../../../components/common/Divider";
import DropDown from "../../../../components/common/DropDown";
import EducationalPage from "./DropdownTable/EducationalPage";
import FamilyPage from "./DropdownTable/FamilyPage";
import CivilPage from "./DropdownTable/CivilPage";
import VoluntaryPage from "./DropdownTable/VoluntaryPage";
import WorkPage from "./DropdownTable/WorkPage";
import LearningPage from "./DropdownTable/LearningPage";
import OtherPage from "./DropdownTable/OtherPage";
import { upsertUseCase } from "../../../../usecases/object";
import FormFactory from "../../../../components/FormFactory";

export default class OtherInfo extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new EmployeeFormPresenter(this);
    this.state = {};
  }
  getCollectionName() {
    return "employees";
  }
  upsertUserCase() {
    return upsertUseCase();
  }

  render() {
    const object = this.props.object;

    sessionStorage.setItem("email", object.email);

    // const schema = this.getSchema(this.getCollectionName());
    const schema = this.props.schema;
    return (
      <>
        <div>
          <Divider title={"Other Information"} />
          <br></br>
          <DropDown
            dropdowns={[
              {
                title: "Family Background",
                content: (
                  <>
                    <div className="row">
                      <FormFactory
                        className="col-lg-4 p-1"
                        uppercase
                        schema={schema}
                        showTabs={false}
                        object={object}
                        onChange={this.onChange.bind(this)}
                        // excludeFields={spouse}
                      />
                      <div className="mt-4">
                        <p className="small fw-bold mb-0 ms-1">Children</p>
                        <hr />
                      </div>
                      <FamilyPage object={object} />
                    </div>
                  </>
                ),
              },
              {
                title: "Educational Background",
                content: (
                  <>
                    <EducationalPage object={object} />
                  </>
                ),
              },
              {
                title: "Civil Service Eligibility",
                content: (
                  <>
                    <CivilPage object={object} />
                  </>
                ),
              },
              {
                title: "Voluntary Work",
                content: (
                  <>
                    <VoluntaryPage object={object} />
                  </>
                ),
              },
              {
                title: "Work Experiences",
                content: (
                  <>
                    <WorkPage object={object} />
                  </>
                ),
              },
              {
                title: "Learning and Development",
                content: (
                  <>
                    <LearningPage object={object} />
                  </>
                ),
              },
              {
                title: "Other Information",
                content: (
                  <>
                    <OtherPage object={object} />
                  </>
                ),
              },
            ]}
          />
        </div>

        <div className="mt-4 d-flex justify-content-end">
          <div className="border" style={{ borderRadius: "4px" }}>
            <button
              style={{
                borderRadius: "4px 0 0 4px",
                backgroundColor: "#29457c",
              }}
              disabled={this.props.isSubmitting}
              onClick={() => {
                if (this.props.isSubmitting) return;
                (this.props.presenter || this.presenter).showDialogSubmit(
                  this.props.object,
                );
              }}
              className="btn btn-primary fs-sm me-0"
            >
              {this.props.isSubmitting ? "Saving..." : "Submit"}
            </button>
            <button
              style={{ borderRadius: "0", backgroundColor: "#fff" }}
              type="button"
              className="btn btn-light fs-sm me-0"
              onClick={this.props.onClickPrev}
            >
              Previous
            </button>
            <button
              style={{
                borderRadius: " 0 4px 4px 0",
                backgroundColor: "#29457c",
              }}
              onClick={this.props.onChangeTab}
              className="btn btn-primary fs-sm me-0"
            >
              Next
            </button>
          </div>
        </div>
      </>
    );
  }
}
